import React, { useState, useEffect, useRef, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import { DataGrid } from "@material-ui/data-grid";
import { notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import Select from "react-select";
import { ProductService } from "../../../services/product-service";
import { ReportService } from "../../../services/reports-service";

export const Content = (props) => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }
    });
  }, [authPermission]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [count, setDataCount] = useState(0);

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productId, setProductId] = useState("");
  const [products, setProductDetails] = useState([]);
  const [selectedProductOption, setSelectedProductOption] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const productSearch = async () => {
    try {
      const result = await ProductService.allproductsNames();
      setProductDetails(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };
  

  const productsDetailsSearch = async (productId = "") => {
    try {
      const result = await ReportService.reportProductDetailsSearch(productId, rowsPerPage, page);
      setFilteredProducts(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };
  
  useEffect(() => {
    productSearch();
  }, []);
  
  useEffect(() => {
    productsDetailsSearch(productId);
  }, [productId, rowsPerPage, page]);
  

  const handleProductChange = (selectedOption, index) => {
    setSelectedProductOption(selectedOption);
    setProductId(selectedOption ? selectedOption.value : "");
  };

  const ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),
  }));

  const filterProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const clearFilters = () => {
    productSearch();
    setSelectedProductOption(null);
    setProductId("");
    setPage(0);
    setRowsPerPage(10);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: 'left',
    },
    {
      field: "name",
      headerName: "Product Name",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "totalGrnStock",
      headerName: "Total GRN",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left", 
      align: "center",
    },
    {
      field: "totalGdnStock",
      headerName: "Total GDN",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "totalStock",
      headerName: "Total Stock",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "completedQuantity",
      headerName: "Completed",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "pendingQuantity",
      headerName: "Pending",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "readyToShipQuantity",
      headerName: "Ready To Ship",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "shippedQuantity",
      headerName: "Shipped",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "balance",
      headerName: "Balance",
      flex: 2,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
      renderCell: (params) => {
        return <div>{params.row.totalStock - (params.row.completedQuantity + params.row.pendingQuantity + params.row.readyToShipQuantity + params.row.shippedQuantity)}</div>;
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-10">
                  <h6>Stock Summary List </h6>
                </div>
                <div className="col-md-6 mt-4">
                  <Select
                    options={ProductOptions}
                    onChange={handleProductChange}
                    isClearable
                    placeholder="Filter by Product"
                    filterOption={filterProductOption}
                    value={selectedProductOption}
                  />
                </div>
                <div className="col-md-1">
                <label htmlFor="validationCustom15"></label>
                <div className="input-group">
                  <button
                      type="button"
                      className="btn btn-secondary shadow-none"
                      onClick={clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                  <DataGrid
                    rows={filteredProducts}
                    columns={columns}
                    disableExtendRowFullWidth={false}
                    pageSize={rowsPerPage}
                    pagination
                    hideFooter
                    autoHeight
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                          whiteSpace: 'normal !important', // allow wrapping
                          lineHeight: '1.2 !important',     // adjust line height
                          overflow: 'visible !important',   // prevent cut-off
                          textOverflow: 'unset !important', // disable ellipsis
                        },
                        '& .MuiDataGrid-columnHeaders': {
                          maxHeight: 'none !important',     // allow taller header
                        }
                      }}
                  />
                  <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
